import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { formatLongDate } from '../lib/officerUtils';
interface EditorialHeaderProps {
  selectedDate: string;
  onDateChange: (date: string) => void;
  officerCount: number;
}
export function EditorialHeader({
  selectedDate,
  onDateChange,
  officerCount
}: EditorialHeaderProps) {
  const dateInputRef = useRef<HTMLInputElement>(null);
  const openPicker = () => {
    const el = dateInputRef.current;
    if (!el) return;
    // Native date picker — showPicker() is the reliable modern API;
    // fall back to focus + click for browsers that don't support it.
    if (typeof el.showPicker === 'function') {
      try {
        el.showPicker();
        return;
      } catch {
        // showPicker can throw if not user-activated — fall through
      }
    }
    el.focus();
    el.click();
  };
  return <header className="border-b border-ink-10" data-id="element-27">
      <div className="w-full px-8 lg:px-12 xl:px-16 pt-14 pb-10" data-id="element-28">
        <div className="flex items-end justify-between gap-8 flex-wrap" data-id="element-29">
          <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-30">
            <div className="font-serif font-bold text-xs tracking-[0.28em] uppercase text-primary/70 mb-3" data-id="element-31">
              The Floor · Daily Briefing
            </div>
            <h1 className="font-serif font-bold text-6xl md:text-7xl text-primary leading-[0.95] tracking-tight" data-id="element-32">
              Today on the floor.
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex flex-col items-end gap-3 pb-2" data-id="element-33">
            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-ink-50" data-id="element-34">
              <span className="relative flex h-2 w-2" data-id="element-35">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-signal opacity-60" data-id="element-36"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-signal" data-id="element-37"></span>
              </span>
              {officerCount} loan officers on the floor
            </div>

            <button type="button" onClick={openPicker} aria-label={`Change date — currently ${formatLongDate(selectedDate)}`} className="group relative cursor-pointer flex items-baseline gap-3 border-b border-primary/30 hover:border-primary focus:outline-none focus-visible:border-primary transition-colors pb-1" data-id="element-38">
              <span className="font-serif font-bold text-lg text-primary" data-id="element-39">
                {formatLongDate(selectedDate)}
              </span>
              <span className="text-xs uppercase tracking-[0.22em] text-primary/50 group-hover:text-primary transition-colors" data-id="element-40">
                Change
              </span>
              <input ref={dateInputRef} type="date" value={selectedDate} onChange={e => onDateChange(e.target.value)} tabIndex={-1} aria-hidden="true" className="absolute bottom-0 left-0 h-px w-px opacity-0 pointer-events-none" data-id="element-41" />
            </button>
          </motion.div>
        </div>
      </div>
    </header>;
}